import styles from "./index.module.scss"
import { usePlanContext } from "../../context"
import intl from "react-intl-universal"

export default function ListDiff() {
  const { nDiffUsers, nDiffSpace, aDiffModules } = usePlanContext()

  return (
    <ul className={styles.container}>
      {nDiffUsers !== 0 && (
        <li className={`${styles.item} ${nDiffUsers > 0 ? styles.green : styles.red}`}>
          {nDiffUsers > 0 && "+ "}
          {nDiffUsers} {intl.get(Math.abs(nDiffUsers) > 1 ? "plan.users" : "plan.user")}
        </li>
      )}
      {nDiffSpace !== 0 && (
        <li className={`${styles.item} ${nDiffSpace > 0 ? styles.green : styles.red}`}>
          {nDiffSpace > 0 && "+ "}
          {nDiffSpace} GB
        </li>
      )}
      {aDiffModules.map((oMod) => (
        <li
          key={oMod.mod_nid}
          className={`${styles.item} ${oMod.bAdded ? styles.green : styles.red}`}
        >
          {oMod.bAdded ? "+" : "-"} {oMod.mod_cname}
        </li>
      ))}
    </ul>
  )
}
